import './style.scss';

console.log(`Child theme front loaded!`)
